/* global document */
import React from "react"
import ReactDOM from "react-dom"
import "./assets/styles/suit.css"
import App from "./App"
import registerServiceWorker from "./registerServiceWorker"
import "./initializeI18n"

// eslint-disable-next-line react/no-deprecated
ReactDOM.render(<App />, document.getElementById("root"))
registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js